<form>
  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Email</mat-label>
      <input
        matInput
        placeholder="Email"
        name="email"
        [(ngModel)]="bbinvitation.email"
        #emailInput="ngModel"
        required
        email
        />
      </mat-form-field>
      @if (
        isSubmitted &&
        (emailInput.errors?.['required'] || emailInput.errors?.['email'])
        ) {
        <mat-error
          class="validation-error"
          >
          Please enter a valid email.
        </mat-error>
      }
    </div>
    <div class="mb-10"></div>

    <div class="form-fields">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Case ID Number</mat-label>
        <input
          matInput
          class="form-control-textbox"
          [(ngModel)]="bbinvitation.caseIdNumber"
          name="caseIdNumber"
          />
        </mat-form-field>
      </div>
      <div class="mb-10"></div>

      <div class="form-fields">
        <mat-form-field>
          <mat-label>Coach</mat-label>
          <mat-select
            placeholder="Select"
            name="coach"
            [(ngModel)]="bbinvitation.coachId"
            [disabled]="bbinvitation.isCoach"
            >
            @for (user of bbcoacheduser; track user) {
              <mat-option [value]="user.userDbId">
                {{ user.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (isSubmitted && bbinvitation.coachId == 0) {
          <mat-error
            class="validation-error"
            >Coach is required</mat-error
            >
        }
      </div>
      <div class="mb-10"></div>

      <div class="form-fields">
        <mat-form-field>
          <mat-label>Language</mat-label>
          <mat-select
            name="language"
            [(ngModel)]="bbinvitation.languageId"
            >
            <mat-option [value]="1">English</mat-option>
            <mat-option [value]="2">Français</mat-option>
          </mat-select>
        </mat-form-field>
        @if (isSubmitted && (bbinvitation.languageId == null || bbinvitation.languageId == 0)) {
          <mat-error class="validation-error">Language is required</mat-error>
        }
      </div>
      <div class="mb-10"></div>

      <div class="form-fields">
        <mat-form-field>
          <mat-label>Program</mat-label>
          <mat-select
            placeholder="Select"
            name="program"
            [(ngModel)]="bbinvitation.program"
            >
            <mat-option [value]="0">Select</mat-option>
            @for (prog of program; track prog) {
              <mat-option [value]="prog.id">
                {{ prog.programName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (isSubmitted && bbinvitation.program == 0) {
          <mat-error
            class="validation-error"
            >Program is required</mat-error
            >
          }
        </div>
        <div class="mb-10"></div>

        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always" class="w-10p0">
            <mat-label>Expected Program Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="dp4"
              [(ngModel)]="bbinvitation.programStartDate"
              name="programstartdate"
              placeholder="DD/MM/YYYY"
              required
              (dateChange)="setExpectedExpiryDate($event)"
              />

              <mat-datepicker-toggle matIconSuffix [for]="dp4"></mat-datepicker-toggle>
              <mat-datepicker #dp4></mat-datepicker>
            </mat-form-field>
            @if (isSubmitted && bbinvitation.programStartDate == null) {
              <mat-error
                class="validation-error"
                >Start Date is required</mat-error
                >
            }
          </div>

          <div class="mb-10"></div>

          <div class="form-fields">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Link Expiry Date</mat-label>
              <input
                matInput
                [matDatepicker]="dp5"
                [(ngModel)]="bbinvitation.linkExpiryDate"
                name="linkexpirydate"
                placeholder="DD/MM/YYYY"
                required
                />

                <mat-datepicker-toggle matIconSuffix [for]="dp5"></mat-datepicker-toggle>
                <mat-datepicker #dp5></mat-datepicker>
              </mat-form-field>
              @if (isSubmitted && bbinvitation.linkExpiryDate == null) {
                <mat-error
                  class="validation-error"
                  >Expiry Date is required</mat-error
                  >
              }
              @if (isSubmitted && !chkLinkExpiryDate()) {
                <mat-error
                  class="validation-error"
                  >Expiry Date should be greater than today and program start
                  date.</mat-error
                  >
                }
              </div>

              <div class="mb-10"></div>

              <div>
                Status
                <div class="toggle">
                  <div class="switch-div">
                    <input
                      type="radio"
                      name="sizeBy"
                      [value]="true"
                      id="active"
                      class="active"
                      [(ngModel)]="bbinvitation.isActive"
                      />
                      <label for="active">Active</label>
                    </div>
                    <div class="switch-div">
                      <input
                        type="radio"
                        name="sizeBy"
                        [value]="false"
                        id="inactive"
                        class="inactive"
                        [(ngModel)]="bbinvitation.isActive"
                        />
                        <label for="inactive">Withdrawn</label>
                      </div>
                    </div>
                  </div>

                  <div class="mb-10"></div>
                </form>
                <div class="mb-10"></div>
